import { getConfig } from '../config/configService';
import { FETCH } from '../components/Fetch/middleware';

export const PLAID_START = '@PLAID/PLAID_START';
export const PLAID_SUCCESS = '@PLAID/PLAID_SUCCESS';
export const PLAID_EXIT = '@PLAID/PLAID_EXIT';

export const startPlaid = (payload) => {
  const config = getConfig();
  return {
    type: PLAID_START,
    [FETCH]: {
      method: 'POST',
      url: `${config.plaidDevUrl}/session`,
      data: payload.data,
      success: payload.success,
    },
  };
};

export const succeedPlaid = (payload) => {
  const config = getConfig();
  return {
    type: PLAID_SUCCESS,
    [FETCH]: {
      method: 'POST',
      url: `${config.plaidDevUrl}/session/${payload.data.sessionId}/token/public`,
      data: payload.data.payload,
      success: payload.success,
    },
  };
};

export const exitPlaid = (payload) => {
  const config = getConfig();
  return {
    type: PLAID_EXIT,
    [FETCH]: {
      method: 'POST',
      url: `${config.plaidDevUrl}/session/${payload.data.sessionId}/exit`,
      data: payload.data.payload,
      success: payload.success,
    },
  };
};
